import React from 'react';

// 格式化文本组件
const FormattedText: React.FC<{ text: string }> = ({ text }) => {
  const formatText = (text: string) => {
    // 分割文本为段落
    const paragraphs = text.split('\n\n').filter(p => p.trim());
    
    return paragraphs.map((paragraph, index) => {
      // 处理粗体标记
      const formattedParagraph = paragraph
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\n/g, '<br/>');
      
      return (
        <div 
          key={index}
          dangerouslySetInnerHTML={{ __html: formattedParagraph }}
          style={{ 
            marginBottom: paragraph.includes('**') ? '12px' : '8px',
            textAlign: 'left'
          }}
        />
      );
    });
  };

  return <div>{formatText(text)}</div>;
};

export default FormattedText;
